import Aprender from './Aprender';
import Carregando from './Carregando';
import CartaoDeCredito from './CartaoDeCredito';
import Confirmacao from './Confirmacao';
import Dispositivos from './Dispositivos';
import Erro from './Erro';
import Estudante from './Estudante';
import NaoEncontrado from './NaoEncontrado';
import Parabens from './Parabens';

export const AnimacaoAprender = Aprender;
export const AnimacaoCarregando = Carregando;
export const AnimacaoCartaoDeCredito = CartaoDeCredito;
export const AnimacaoConfirmacao = Confirmacao;
export const AnimacaoDispositivos = Dispositivos;
export const AnimacaoErro = Erro;
export const AnimacaoEstudante = Estudante;
export const AnimacaoNaoEncontrado = NaoEncontrado;
export const AnimacaoParabens = Parabens;
